import React from "react";
import { collections } from "../mock";

export default function Collections() {
  return (
    <section className="section bg-[#FBF8F4]">
      <div className="container-y">
        <div className="text-center mb-14">
          <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-3">
            Signature lines
          </p>
          <h2 className="font-serif-y text-3xl md:text-5xl text-[#1a1a1a]">
            Explore Our Collections
          </h2>
          <div className="gold-divider w-32 mx-auto mt-8" />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {collections.map((c) => (
            <a
              key={c.title}
              href={c.href}
              target="_blank"
              rel="noreferrer"
              className="group relative block overflow-hidden bg-[#F5EFE6] aspect-[3/4]"
            >
              <img
                src={c.img}
                alt={c.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 text-center">
                <h3 className="font-serif-y text-2xl md:text-3xl text-white drop-shadow-md">
                  {c.title}
                </h3>
                <span className="inline-block mt-2 font-sans-y text-[10px] tracking-[0.3em] uppercase text-white/90 border-b border-white/70 pb-0.5">
                  Shop now
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
